import {IApiEndpoint, IObjectCounter, IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import type {IContaContabil} from "@models/contaContabil/contaContabil.ts";
import type {IContasContabeisFiltroDto, ICreateContaContabilDto} from "@models/contaContabil/createContaContabilDto.ts";
import {siteMapApi} from "@localization/siteMap/siteMap.ts";
import {GastosContasContabeisFilters} from "@models/contaContabil/ContaContabilFilterDto.tsx";
import {IContaContabilRecursoLimite} from "@models/contaContabil/IContaContabilRecursoLimite.ts";
import {ICcValorDistribuivelFilter} from "@models/contaContabil/Filters/ICcValorDistribuivelFilter.ts";
import {ICcValorDistribuivel} from "@models/contaContabil/ICcValorDistribuivel.ts";
import {INewCcValorDistribuivel} from "@models/contaContabil/valorDistribuivel/INewCcValorDistribuivel.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";

export const __contacontabil_endpoints = {
    createContaContabil: (body: ICreateContaContabilDto): IApiEndpoint => ({
        url: '/api/ContaContabil/CreateContaContabil',
        body: body,
        method: "POST"
    }),
    getContasContabeisPesquisa: (search: string, pagination: IPagination): IApiEndpoint => ({
        url: '/api/ContaContabil/GetContasContabeisPesquisa',
        pagination: pagination,
        query: {search},
        method: "GET"
    }),
    getContasContabeis: (query: IContasContabeisFiltroDto, pagination: IPagination): IApiEndpoint<IContaContabil[]> => ({
        url: '/api/ContaContabil/GetContasContabeis',
        pagination: pagination,
        query: query,
        method: "GET"
    }),
    GetContasContabeisValoresDistribuiveis: (query: ICcValorDistribuivelFilter, pagination: IPagination): IApiEndpoint<ICcValorDistribuivel[]> => ({
        url: '/api/ContaContabil/GetContasContabeisValoresDistribuiveis',
        query: query,
        method: "GET",
        pagination: pagination,
    }),
    CreateCcValorDistribuivel: (body: INewCcValorDistribuivel): IApiEndpoint<ICcValorDistribuivel> => ({
        url: '/api/ContaContabil/CreateContaContabilValorDistribuivel',
        body: body,
        method: "POST",
    }),
    ['import-conta-contabil']: (data: IDataNoPageDto<ICreateContaContabilDto[]>): IApiEndpoint<IContaContabil[]> => {
        return {
            url: '/api/ContaContabil/ImportContasContabeis',
            method: "POST",
            data: data,
        } as IApiEndpoint<IContaContabil[]>
    },
    ['v2']: {
        ['get-contas-contabeis']: (data: IDataDto<IContasContabeisFiltroDto>): IApiEndpoint<IContaContabil[]> => {
            return {
                url: '/api/v2/ContasContabeis',
                method: "GET",
                data: data,
            }
        }
    },
}

export const CreateContaContabil = (body: ICreateContaContabilDto) => {
    const endpoint = __contacontabil_endpoints.createContaContabil(body);

    return siteMapApi.request<IContaContabil>(endpoint);
}

export const GetContasContabeis = (query: IContasContabeisFiltroDto, pagination: IPagination) => {
    return __contacontabil_endpoints.getContasContabeis(query, pagination);
}

export const GetContaContabilLimitesRecurso = (query: {
    recursoId?: number,
    contaContabilId?: number,
    search?: string
}, pagination: IPagination): IApiEndpoint<IContaContabil[]> => {
    return {
        url: '/api/ContaContabil/GetLimitesContaContabilRecurso',
        pagination: pagination,
        query: query,
        method: "GET",
    }
}

export const GetGastosContasContabeis = (query: GastosContasContabeisFilters, pagination: IPagination): IApiEndpoint<IObjectCounter[]> => {
    return {
        url: '/api/ContaContabil/GetGastosContaContabil',
        pagination: pagination,
        query: {
            dataFim: query.dataFim,
            dataInicio: query.dataInicio,
            filtrarPor: query.filtrarPor,
            idContaContabil: query.idContaContabil
        } as GastosContasContabeisFilters,
        method: "GET",
    }
}

export const CreateOrUpdateLimiteContaContabilRecurso = (body: IContaContabilRecursoLimite[]): IApiEndpoint<IContaContabilRecursoLimite[]> => {
    return {
        url: '/api/ContaContabil/CreateOrUpdateLimiteContaContabilRecurso',
        body: body,
        method: "PUT",
    }
}